import { render, staticRenderFns } from "./ImageALevel.vue?vue&type=template&id=3b8c4c13&scoped=true&"
import script from "./ImageALevel.vue?vue&type=script&lang=js&"
export * from "./ImageALevel.vue?vue&type=script&lang=js&"
import style0 from "./ImageALevel.vue?vue&type=style&index=0&id=3b8c4c13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c4c13",
  null
  
)

export default component.exports